// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3JJm1","signatureBlock":"Footer_signatureBlock__4-1os","signature":"Footer_signature__rXMpA"};